import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import style from './amazon-redacted-info-banner.module.less';
import { messages } from './messages';
import HelpArticleLink from '../../../components/help-article-link';
import { linkIDs } from '../../../services/link-service/links';
import { hasRedactedInformation } from '../../../services/redacted-information-service';
import Global from '../../../store/global-selectors';

export const AmazonRedactedInfoBanner = ({ salesOrderId }) => {
  const isRedacted = useSelector((state) => {
    const soldToName = Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'soldTo.name',
    });
    return hasRedactedInformation(soldToName);
  });

  return (
    isRedacted && (
      <BannerMessageV2
        bannerContainerClassName={style['banner-message-text']}
        className={style['banner-message']}
        content={
          <FormattedMessage
            {...messages.amazonRedactedInfoBanner}
            values={{
              a: (chunks) => <HelpArticleLink articleId={linkIDs.AmazonMarketplace}>{chunks}</HelpArticleLink>,
            }}
          />
        }
        status={BannerStatus.Info}
      />
    )
  );
};

AmazonRedactedInfoBanner.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
};
